import React from 'react';
import { TextField } from '@mui/material';

function ReadOnlyBar({ currentValue, placeholder }) {
    return (
        <div>
            <TextField
                variant="outlined"
                value={currentValue}
                size="small"
                placeholder={placeholder}
                disabled
                sx={{
                    mt: 1,
                    mb: 1,
                    width: '100%',
                    backgroundColor: '#f0f0f0', // Gray background
                    "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: '#b0b0b0', // Light gray border
                    },
                }}
                InputProps={{
                    readOnly: true,
                    sx: {
                        fontSize: 13,
                        padding: 1,
                    },
                }}
                InputLabelProps={{
                    sx: {
                        fontSize: 13,
                        padding: 1,
                    },
                }}
            />
        </div>
    );
}

export default ReadOnlyBar;
